"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _UIDeviceFrameDesktop = _interopRequireDefault(require("./UIDeviceFrameDesktop"));

var _UIDeviceFrameTablet = _interopRequireDefault(require("./UIDeviceFrameTablet"));

var _UIDeviceFrameMobile = _interopRequireDefault(require("./UIDeviceFrameMobile"));

var DEVICE_TYPES = {
  desktop: _UIDeviceFrameDesktop.default,
  tablet: _UIDeviceFrameTablet.default,
  mobile: _UIDeviceFrameMobile.default
};

var UIDeviceFrame =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(UIDeviceFrame, _React$Component);

  function UIDeviceFrame() {
    (0, _classCallCheck2.default)(this, UIDeviceFrame);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UIDeviceFrame).apply(this, arguments));
  }

  (0, _createClass2.default)(UIDeviceFrame, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          contentClassName = _this$props.contentClassName,
          height = _this$props.height,
          orientation = _this$props.orientation,
          type = _this$props.type,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["children", "className", "contentClassName", "height", "orientation", "type"]);
      var DeviceFrame = DEVICE_TYPES[type];

      if (type === 'desktop' && orientation === 'landscape') {
        _devLogger.default.warn({
          message: "UIDeviceFrame: There is no designed state for a landscape desktop device frame.\n          Change either the `type` or the `orientation`",
          key: 'UIDeviceFrame: landscape desktop'
        });
      }

      if (height && type !== 'desktop') {
        _devLogger.default.warn({
          message: "UIDeviceFrame: Only the desktop device frame applies the height prop.",
          key: 'UIDeviceFrame: height only applies to desktop'
        });
      }

      return _react.default.createElement(DeviceFrame, (0, _extends2.default)({}, rest, {
        className: className,
        contentClassName: contentClassName,
        height: height,
        orientation: orientation
      }), children);
    }
  }]);
  return UIDeviceFrame;
}(_react.default.Component);

UIDeviceFrame.propTypes = {
  children: _react.PropTypes.node.isRequired,
  contentClassName: _react.PropTypes.string,
  height: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
  orientation: _react.PropTypes.oneOf(['portrait', 'landscape']),
  type: _react.PropTypes.oneOf(Object.keys(DEVICE_TYPES))
};
UIDeviceFrame.defaultProps = {
  orientation: 'portrait',
  type: 'desktop'
};
UIDeviceFrame.displayName = 'UIDeviceFrame';
var _default = UIDeviceFrame;
exports.default = _default;
module.exports = exports.default;